import React from 'react';
import Footer from '../../Shared/Footer';
import Header from '../../Shared/Header';

const NotFound = () => {
    return (
        <div>

            <div>
                <Header></Header>
            </div>
            <div> <h1>404  not found </h1></div>
            <div>
                <Footer></Footer>
            </div>



        </div>
    );
};

export default NotFound;